import { cn } from "@lib/cn";
import { forwardRef } from "react";
import { useCarouselCtx } from "../ctx";

interface IProps {
  type: "next" | "prev";
}

export const CarouselNavBtn = forwardRef<HTMLDivElement, IProps>(
  ({ type }, ref) => {
    const { isFullScreen } = useCarouselCtx();
    return (
      <div
        ref={ref}
        data-carousel-nav-btn={type}
        className={cn({
          "carousel-nav-btn tw-absolute tw-top-1/2 tw-z-10 tw-flex -tw-translate-y-1/2 tw-items-center tw-justify-center tw-self-center tw-rounded-full tw-bg-white tw-shadow-sm tw-outline tw-outline-1": true,
          "tw-size-10": true,
          "tw-left-1 md:tw-left-4": type === "prev",
          "tw-right-1 md:tw-right-4": type === "next",
          "max-md:tw-opacity-90": isFullScreen,
        })}
        style={{
          outlineColor: "rgba(18, 3, 62, 0.05)",
        }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {/* The ink must be pinned to a colour that exists in the Tailwind
            palette. This theme has no `gray`/`neutral` scale, so `tw-text-gray-*`
            compiles to nothing and the icon falls back to inherited colour —
            which in the reader is `body { color: var(--paragraph-color) }`, i.e.
            white under a dark-mode design system, on this hardcoded white circle. */}
        <i
          className={cn({
            [`ri-arrow-${type === "prev" ? "left" : "right"}-line`]: true,
            "tw-relative tw-text-base tw-text-blue-base md:tw-text-2xl": true,
          })}
        />
      </div>
    );
  },
);
